import '../styles/exam/DigitalSAT.css';

import { LOCAL_BASE_URL, PURCHASE_TOGGLE } from '../constants/constants';
import React, { useEffect, useState } from 'react';
import { resetTest, setAttempt, setExamId } from '../store/testSelectionSlice';
import { useDispatch, useSelector } from 'react-redux';

import { Box } from '@mui/material';
import Label from '../components/atoms/Label';
import axiosRequestInterceptor from '../interceptor/axiosAPIRequestInterceptor';
import { logger } from '../utils/logger';
import { resetExam } from '../store/ExamSlice';
import { useNavigate } from 'react-router-dom';

const DigitalSAT = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const api = axiosRequestInterceptor;
	const [examTests, setExamTests] = useState([]);
	const [loading, setLoading] = useState(false);

	const { emailId, userId } = useSelector((state) => state.userDetails);

	// let examTests = [
	// 	{ id: 1, title: "DSAT Practice Test 1", isFree: true, hasStart: true },
	// 	{ id: 2, title: "DSAT Practice Test 2", isFree: false, isPremium: true },
	// 	{ id: 3, title: "DSAT Practice Test 3", isFree: false, isPremium: true },
	// 	{ id: 4, title: "DSAT Practice Test 4", isFree: false, isPremium: true },
	// 	{ id: 5, title: "DSAT Practice Test 5", isFree: false, isPremium: true },
	// 	{ id: 6, title: "DSAT Practice Test 6", isFree: false, isPremium: true },
	// 	{ id: 7, title: "DSAT Practice Test 1", isFree: true, hasStart: true },
	// 	{ id: 8, title: "DSAT Practice Test 2", isFree: false, isPremium: true },
	// 	{ id: 9, title: "DSAT Practice Test 3", isFree: false, isPremium: true },
	// 	{ id: 10, title: "DSAT Practice Test 4", isFree: false, isPremium: true },
	// 	{ id: 11, title: "DSAT Practice Test 5", isFree: false, isPremium: true },
	// 	{ id: 12, title: "DSAT Practice Test 6", isFree: false, isPremium: true },
	// ];

	useEffect(() => {
		const fetchExams = async () => {
			try {
				setLoading(true);
				const response = await api.post(`/exam/getExamsList`, {
					userId: userId,
					email: emailId,
				});
				logger.log('response.data', response.data);
				setExamTests(response?.data?.exams);
			} catch (error) {
				logger.log('Error fetching exams:', error);
			} finally {
				setLoading(false);
			}
		};
		dispatch(resetExam());
		dispatch(resetTest());
		fetchExams();
	}, []);

	const handleStartTest = (testId) => {
		const id = testId.split('#')[1];
		dispatch(setExamId(id));
		navigate(`/test/loading/${testId}`);
	};

	const hadleViewScore = (testId) => {
		const id = testId.split('#')[1];
		dispatch(setExamId(id));
		dispatch(setAttempt(1));
		navigate('/exam-score');
	};

	return (
		<div className="exam-container">
			<div
				style={{
					display: 'flex',
					justifyContent: 'flex-start',
					alignItems: 'center',
					marginBottom: '30px',
					marginTop: '50px',
				}}
			>
				<Label
					label="Digital SAT Exam"
					fontSize="31px"
					fontWeight="700"
					color="#1F21E6"
					textAlign="left"
					margin="0px"
					padding="0px"
				/>
			</div>
			<div className="exam-description">
				<Label
					label="Brand name offers authentic practices that are closely modeled after the actual test. 
           Our questions are specifically designed to better prepare you for when it really counts Good Luck!"
					fontSize="16px"
					fontWeight="400"
					color="#000000"
					textAlign="left"
					margin="0px"
					padding="0px"
				/>
			</div>

			{loading ? (
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						minHeight: '200px',
					}}
				>
					<div className="loader"></div>
				</Box>
			) : (
				<div className="tests-grid">
					{examTests?.map((test) => (
						<div key={test?.examId} className="test-card">
							<div className="test-header">
								<Label
									label={test?.examName}
									fontSize="20px"
									fontWeight="400"
									color="#000000"
									textAlign="left"
									margin="0px"
									padding="0px"
								/>
								{test?.isFree && <span className="free-badge">Free</span>}
							</div>
							<div className="test-actions">
								{test?.isFree || test?.hasAccess ? (
									<div>
										Attempts remaining: {test?.attemptInfo?.remainingAttempts}
									</div>
								) : (
									<div></div>
								)}
								<div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
									{test?.attemptInfo?.completedAttempts > 0 && (
										<button
											className="start-button"
											onClick={() => hadleViewScore(test?.examId)}
										>
											View Score
										</button>
									)}
									{test?.isFree || test?.hasAccess || !PURCHASE_TOGGLE ? (
										<button
											className="start-button"
											disabled={test?.attemptInfo?.remainingAttempts === 0}
											onClick={() => handleStartTest(test?.examId)}
										>
											Start
										</button>
									) : (
										test?.isPremium && (
											<span className="premium-badge">Premium</span>
										)
									)}
								</div>
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default DigitalSAT;
